'use strict';

/**
 * Dependencies
 * @ignore
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var base64url = require('base64url');
var crypto = require('@trust/webcrypto');
var TextEncoder = require('../text-encoder');

/**
 * RSASSA-PKCS1-v1_5
 */

var RSASSA_PKCS1_v1_5 = function () {

  /**
   * constructor
   *
   * @param {string} bitlength
   */
  function RSASSA_PKCS1_v1_5(params) {
    _classCallCheck(this, RSASSA_PKCS1_v1_5);

    this.params = params;
  }

  /**
   * sign
   *
   * @description
   * Generate a digital signature for a given input and private key.
   *
   * @param {CryptoKey} key
   * @param {(BufferSource|String)} data
   *
   * @returns {Promise}
   */


  _createClass(RSASSA_PKCS1_v1_5, [{
    key: 'sign',
    value: function sign(key, data) {
      var algorithm = this.params;

      // TODO
      //if (!this.sufficientKeySize()) {
      //  return Promise.reject(
      //    new Error(
      //      'A key size of 2048 bits or larger must be used with RSASSA-PKCS1-v1_5'
      //    )
      //  )
      //}

      // Normalize data input
      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      }

      return crypto.subtle.sign(algorithm, key, data).then(function (signature) {
        return base64url(Buffer.from(signature));
      });
    }

    /**
     * verify
     *
     * @description
     * Verify a digital signature for a given input and private key.
     *
     * @param {CryptoKey} key
     * @param {(BufferSource|String)} signature - Base64URL encoded signature.
     * @param {(BufferSource|String)} data
     *
     * @returns {Promise}
     */

  }, {
    key: 'verify',
    value: function verify(key, signature, data) {
      var algorithm = this.params;

      // Normalize signature
      if (typeof signature === 'string') {
        signature = Uint8Array.from(base64url.toBuffer(signature));
      }

      // Normalize data to be verified
      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      }

      return crypto.subtle.verify(algorithm, key, signature, data);
    }

    /**
     * Generate Key
     *
     * @description
     * Generate key pair for RSA.
     *
     * @param {boolean} extractable
     * @param {Array} key_ops
     * @param {Object} options
     *
     * @return {Promise}
     */

  }, {
    key: 'generateKey',
    value: function generateKey(extractable, key_ops) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var params = this.params;
      var modulusLength = options.modulusLength;

      if (modulusLength) {
        params.modulusLength = modulusLength;
      }
      return crypto.subtle.generateKey(params, extractable, key_ops);
    }

    /**
     * importKey
     *
     * @param {JWK} key
     * @returns {Promise}
     */

  }, {
    key: 'importKey',
    value: function importKey(key) {
      var jwk = Object.assign({}, key);
      var algorithm = this.params;
      var usages = key['key_ops'] || [];
      // duplicate key operation values MUST NOT be present
      if (!(usages.length === new Set(usages).size)) {
        return Promise.reject(new Error('Invalid key operations key parameter'));
      }
      if (!usages.includes('verify') && (key.use === 'sig' || !key.d)) {
        usages.push('verify');
      }
      if (key.use === 'enc') {
        return Promise.reject(new Error('Invalid use key parameter'));
      }
      // RSA is used
      // if d parameter is present, this is a private key
      if (jwk.d) {
        if (!usages.includes('sign')) {
          usages.push('sign');
        }
      }

      return crypto.subtle.importKey('jwk', jwk, algorithm, true, usages).then(function (cryptoKey) {
        Object.defineProperty(jwk, 'cryptoKey', {
          enumerable: false,
          value: cryptoKey
        });

        return jwk;
      });
    }
  }]);

  return RSASSA_PKCS1_v1_5;
}();

/**
 * Export
 */


module.exports = RSASSA_PKCS1_v1_5;


// WEBPACK FOOTER //
// ./lib/algorithms/RSASSA-PKCS1-v1_5.js